import { Injectable } from '@angular/core';
import { poe1 } from '../../game';
import { SettingsService } from './settings.service';

const prefix = poe1 ? 'poe1' : 'poe';

const KEY_ONBOARDING_TRACKING = `${prefix}-onboarding-tracking`;
const KEY_VISIT_COUNT = `${prefix}-visit-count`;
const KEY_QF_SESSION_COUNT = `${prefix}-qf-session-count`;
const SESSION_KEY_QF_VISITED = `${prefix}-qf-visited-session`;

const QF_SESSION_THRESHOLD = 3;

@Injectable({
  providedIn: 'root',
})
export class UserOnboardingService {
  constructor(private settings: SettingsService) {}

  initializeOnAppLoad(hadVisitedBefore: boolean): void {
    if (!hadVisitedBefore) {
      localStorage.setItem(KEY_ONBOARDING_TRACKING, '1');
      localStorage.setItem(KEY_VISIT_COUNT, '1');
      localStorage.setItem(KEY_QF_SESSION_COUNT, '0');
      return;
    }

    if (!this.isOnboardingCohort()) {
      return;
    }

    const visitCount = parseInt(localStorage.getItem(KEY_VISIT_COUNT) ?? '0', 10);
    localStorage.setItem(KEY_VISIT_COUNT, String(visitCount + 1));
  }

  trackQuickFiltersVisit(): void {
    if (!this.isOnboardingCohort()) {
      return;
    }

    if (sessionStorage.getItem(SESSION_KEY_QF_VISITED) === '1') {
      return;
    }

    sessionStorage.setItem(SESSION_KEY_QF_VISITED, '1');
    const sessionCount = parseInt(localStorage.getItem(KEY_QF_SESSION_COUNT) ?? '0', 10);
    localStorage.setItem(KEY_QF_SESSION_COUNT, String(sessionCount + 1));
  }

  shouldShowQuickFiltersMainTabBanner(): boolean {
    if (!this.isOnboardingCohort()) {
      return false;
    }

    if (this.settings.quickFiltersAsMainTab()) {
      return false;
    }

    if (!this.settings.showQuickFiltersMainTabBanner()) {
      return false;
    }

    const sessionCount = parseInt(localStorage.getItem(KEY_QF_SESSION_COUNT) ?? '0', 10);
    return sessionCount >= QF_SESSION_THRESHOLD;
  }

  private isOnboardingCohort(): boolean {
    return localStorage.getItem(KEY_ONBOARDING_TRACKING) === '1';
  }
}
